import { render, staticRenderFns } from "./disease_chart.vue?vue&type=template&id=35e38011&scoped=true&"
import script from "./disease_chart.vue?vue&type=script&lang=js&"
export * from "./disease_chart.vue?vue&type=script&lang=js&"
import style0 from "./disease_chart.vue?vue&type=style&index=0&id=35e38011&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e38011",
  null
  
)

export default component.exports